module.exports = {
  presets: [
    'es2015',
    'react',
    'stage-0'
  ],
  plugins: [
    'transform-decorators-legacy'
  ]
}


// WEBPACK FOOTER //
// ./~/picidae-transformer-react-render/lib/babel-standlone-config.js